<h2>Manage Account</h2>
<div class="container">
  <nav mat-tab-nav-bar [tabPanel]="tabPanel">
    @for (link of navLinks; track link; let i = $index) {
      <a mat-tab-link [routerLink]="link.link" routerLinkActive #rla="routerLinkActive" [active]="rla.isActive" class="account-details__link">
        {{ link.label }}
      </a>
    }
  </nav>
  <div class="nav-line"></div>
  <mat-tab-nav-panel #tabPanel></mat-tab-nav-panel>
  <router-outlet></router-outlet>
</div>
